import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, withDirectives as _withDirectives, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-251d785a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "main" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Выбор клиники", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "security" }, [
  /*#__PURE__*/_createTextVNode(" Вы зарегистрированы в нескольких "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" клиниках, выберите нужную: ")
], -1))
const _hoisted_5 = { class: "all-clinics" }
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "security" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Войти ")

import { defineComponent, onMounted, reactive } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
import { authApi } from '@/shared/api'
import WHeaderAuth from '@/widgets/WHeaderAuth/WHeaderAuth.vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()

const choiceClinicForm = reactive({
  clinicList: [],
  selectedClinic: 0,
})

const getClinicList = async (): Promise<void> => {
  const [error, response] = await authApi.getOrganizations()

  if (!error) {
    choiceClinicForm.clinicList = response.data.organizations
  }
}

const handleLoginUser = async (): Promise<void> => {
  if (choiceClinicForm.selectedClinic) {
    const [error] = await authApi.setOrganization(
      choiceClinicForm.selectedClinic
    )

    if (!error) {
      router.push({ name: 'PatientListingPage' })
    }
  } else {
    ElMessage({
      message: 'Выберите клинику',
      type: 'error',
    })
  }
}

onMounted((): void => {
  getClinicList()
})

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(WHeaderAuth, { class: "layout__header" }),
    _createElementVNode("main", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(choiceClinicForm).clinicList, (clinic, index) => {
          return (_openBlock(), _createElementBlock("label", { key: index }, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(choiceClinicForm).selectedClinic) = $event)),
              value: clinic.id,
              name: "clinic",
              type: "radio"
            }, null, 8, _hoisted_6), [
              [_vModelRadio, _unref(choiceClinicForm).selectedClinic]
            ]),
            _createElementVNode("p", _hoisted_7, _toDisplayString(clinic.name), 1)
          ]))
        }), 128))
      ]),
      _createVNode(_component_el_button, {
        class: "clinic-choice__button",
        type: "primary",
        onClick: handleLoginUser
      }, {
        default: _withCtx(() => [
          _hoisted_8
        ]),
        _: 1
      })
    ])
  ]))
}
}

})